import * as React from "react";
import { StyleSheet } from "react-native";
import { Button as NPButton } from "react-native-paper";
import { blackColor, greyDisabledButtonColor, whiteColor } from "../colors";

export default function Button(props) {
  const [isPressedSignInButton, setSignInButton] = React.useState(false);

  const onPress = () => {
    // setSignInButton(true);
    props.onPress();
    // setTimeout(() => setSignInButton(false), 1000)
  };

  const stylesProps = {...props.style}
  const styleOwn = props.disabled ? styles.buttonDisabled : styles.button;
  return (
    <NPButton
      mode={isPressedSignInButton ? "contained" : "outlined"}
      style={[styleOwn, {...stylesProps}]}
      labelStyle={styles.textButton}
      onPress={onPress}
      disabled={props.disabled}
    >
      {props.value}
    </NPButton>
  );
}

const styles = StyleSheet.create({
  textButton: {
    fontFamily: "Roboto",
    fontWeight: "400",
    fontSize: 14,
    padding: 3,
    letterSpacing: 1.25,
  },
  button: {
    borderWidth: 3,
    width: 273,
    borderColor: blackColor,
    backgroundColor: whiteColor,
    height: 48,
  },
  buttonDisabled: {
    borderWidth: 3,
    width: 273,
    borderColor: greyDisabledButtonColor,
    height: 48,
  },
});
